import http from "./httpService";

const apiEndpoint = "/bandwidth";

export function getBandwidthUsage(username, intervalName) {  
  const interval = intervalName.toLowerCase();
  const user = username.toLowerCase();
  return http.get(`${apiEndpoint}/${interval}/${user}`);
}